export async function getSha256Hash(input: string): Promise<string> {
  const encoder = new TextEncoder();
  const data = encoder.encode(input);
  const hashBuffer = await crypto.subtle.digest("SHA-256", data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
  return hashHex;
}

/**
 * Default hardcoded salt for token encryption
 * This is used when no specific salt is provided
 */
export const DEFAULT_SALT = "PrV1dR_S4lT_2025";

async function getKey(): Promise<CryptoKey> {
  const encoder = new TextEncoder();
  const keyData = encoder.encode(DEFAULT_SALT);
  return crypto.subtle.importKey("raw", keyData, { name: "AES-GCM" }, false, [
    "encrypt",
    "decrypt",
  ]);
}

export async function encryptData(plainText: string): Promise<string> {
  const key = await getKey();
  const iv = crypto.getRandomValues(new Uint8Array(12));
  const encoder = new TextEncoder();
  const encryptedBuffer = await crypto.subtle.encrypt(
    { name: "AES-GCM", iv },
    key,
    encoder.encode(plainText)
  );
  const encryptedBase64 = btoa(
    String.fromCharCode(...new Uint8Array(encryptedBuffer))
  );
  return `${btoa(String.fromCharCode(...iv))}.${encryptedBase64}`;
}

export async function decryptData(encrypted: string): Promise<string> {
  const newEncrypted = encrypted.replace("token=", "");
  const [ivBase64, dataBase64] = newEncrypted.split(".");
  const key = await getKey();
  const iv = Uint8Array.from(atob(ivBase64), (c) => c.charCodeAt(0));
  const encryptedData = Uint8Array.from(atob(dataBase64), (c) =>
    c.charCodeAt(0)
  );
  const decryptedBuffer = await crypto.subtle.decrypt(
    { name: "AES-GCM", iv },
    key,
    encryptedData
  );
  return new TextDecoder().decode(decryptedBuffer);
}
